import React, { Component } from 'react'
import Card from './Card'
import Basket from './Basket'

export default class Mobile extends Component {

  render() {
    return (
      <div>
        <Card color="red" borderColor="green" />
        <Card color="orange" borderColor="blue" />
        <Card color="yellow" borderColor="purple" />
        <Basket />
        <div id="console" />
      </div>
    )
  }
}
